import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { getAllCampaigns } from "../../services/CampaignService";
import { Campaign, CampaignFilter } from "../../types/campaign.types";

interface CampaignState {
    campaignList: Campaign[];
    selectedCampaign: Campaign | null;
    loading: boolean;
    error: string | null;
    filters: CampaignFilter;
}

const initialState: CampaignState = {
    campaignList: [],
    selectedCampaign: null,
    loading: false,
    error: null,
    filters: {
        showDeactivated: false,
        sortOrder: 'asc'
    }
};

export const campaignSlice = createSlice({
    name: "campaign",
    initialState,
    reducers: {
        clearError: (state) => {
            state.error = null;
        },
        setFilters: (state, action: PayloadAction<Partial<CampaignFilter>>) => {
            state.filters = {
                ...state.filters,
                ...action.payload
            };
        },
        clearFilters: (state) => {
            state.filters = {
                showDeactivated: false,
                sortOrder: 'asc'
            };
        },
        setSelectedCampaign: (state, action: PayloadAction<Campaign>) => {
            state.selectedCampaign = action.payload;
        },
        clearSelectedCampaign: (state) => {
            state.selectedCampaign = null;
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(getAllCampaigns.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(getAllCampaigns.fulfilled, (state, action) => {
                state.loading = false;
                state.campaignList = action.payload;
            })
            .addCase(getAllCampaigns.rejected, (state, action) => {
                state.loading = false;
                state.error = action.error.message || "Failed to fetch campaigns";
            });
    }
});

export const {
    clearError,
    setFilters,
    clearFilters,
    setSelectedCampaign,
    clearSelectedCampaign
} = campaignSlice.actions;

export default campaignSlice.reducer;
